import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";
import { EnergyMeterService } from "../../../../app/services/energymeter.service";
@Component({
  selector: "app-meter-service-modal",
  templateUrl: "./meter-service-modal.component.html",
  styleUrls: ["./meter-service-modal.component.scss"],
  standalone: true,
  imports: [CommonModule]
})
export class MeterServiceModalComponent implements OnInit {
  public emeterData = BaseUrlConstantsService.energyMeterApi;

  @Input("type") type: string;
  @Input("toggleValue") toggleValue: boolean;
  @Input("subsystem_id") subsystem_id: string;
  @Input("service_id") service_id: string;

  @Output() closeGreasingModal: EventEmitter<any> = new EventEmitter();
  @Output() saveGreasingModalData: EventEmitter<any> = new EventEmitter();

  @Output() closeOFSModal: EventEmitter<any> = new EventEmitter();
  @Output() saveOFSModalData: EventEmitter<any> = new EventEmitter();

  form: FormGroup = new FormGroup({
    last_service_start_date: new FormControl(""),
    last_service_end_date: new FormControl(""),
    last_service_performed: new FormControl(""),
    last_service_performed_by: new FormControl(""),
    next_service_start_date: new FormControl("", {
      validators: [Validators.required],
    }),
    next_service_end_date: new FormControl("", {
      validators: [Validators.required],
    }),
    next_service_performed: new FormControl("", {
      validators: [Validators.required],
    }),
    next_service_performed_by: new FormControl("", {
      validators: [Validators.required],
    }),
    // user_id
    // subsystem_id
  });
  gform: FormGroup = new FormGroup({
    last_greasing_start_date: new FormControl(""),
    last_greasing_end_date: new FormControl(""),
    last_greasing_performed: new FormControl("GREASING"),
    last_greasing_performed_by: new FormControl(""),
    next_greasing_start_date: new FormControl("", {
      validators: [Validators.required],
    }),
    next_greasing_end_date: new FormControl("", {
      validators: [Validators.required],
    }),
    next_greasing_performed: new FormControl("GREASING", {
      validators: [Validators.required],
    }),
    next_greasing_performed_by: new FormControl("", {
      validators: [Validators.required],
    }),
    // user_id
    // subsystem_id
  });
  gformV2: FormGroup = new FormGroup({
    last_greasing: new FormControl(""),
    nxt_running_hrs: new FormControl({ value: "", disabled: true }),
    suggested_greasing_date: new FormControl(""),
  });

  service_data: any = {};
  meter_data: any = {};
  today = "";

  loader = false;

  constructor(private service: EnergyMeterService) {}

  ngOnInit(): void {
    this.service.meterSrvDataObs.subscribe((data) => {
      this.service_data = data;
    });
    this.service.meterDataObs.subscribe((data) => {
      this.meter_data = data;
    });
    if (this.type == "ofs_modal") this.setInitialServiceForm();
    if (this.type == "service_modal") this.setInitialGreasingForm();
    this.getHTMLDateTimeMinFormat();

    if (this.type == "greasing_modal") {
      this.gformV2.get("last_greasing")?.valueChanges.subscribe((value) => {
        if (value) {
          this.gformV2.get("nxt_running_hrs")?.enable(); // Enable if date is entered
        } else {
          this.gformV2.get("nxt_running_hrs")?.disable(); // Disable if date is empty
        }
      });
      this.gformV2.get("nxt_running_hrs")?.valueChanges.subscribe((value) => {
        if (value) this.calculateNextSuggestedGreasinDate(value);
      });
    }
  }

  saveServiceModalDataBox() {
    this.loader = true;
    let body = {
      subsystem_id: this.meter_data.subsystem_id,
      start_date: this.form.value.next_service_start_date,
      end_date: this.form.value.next_service_end_date,
      user_id: this.meter_data.client_id,
      type: "s",
      service_performed: this.form.value.next_service_performed,
      service_performed_by: this.form.value.next_service_performed_by,
    };
    this.service
      .updateServiceRecordData(`${this.emeterData}/service-record`, body)
      // .updateServiceRecordData(
      //   `http://localhost:3105/emeter/service-record`,
      //   body
      // )
      .then((data: any) => {
        if (data.isSuccess) {
          this.saveOFSModalData.emit();
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loader = false;
      });
  }

  closeServiceModalBox() {
    this.closeOFSModal.emit();
  }
  setInitialGreasingForm() {
    this.gform.setValue({
      last_greasing_start_date: this.service_data.greasing.start_date
        ? this.service_data.greasing.start_date.split(" ")[0]
        : "",
      last_greasing_end_date: this.service_data.greasing.end_date
        ? this.service_data.greasing.end_date.split(" ")[0]
        : "",
      last_greasing_performed: this.service_data.greasing.service_performed
        ? this.service_data.greasing.service_performed
        : "",
      last_greasing_performed_by: this.service_data.greasing
        .service_performed_by
        ? this.service_data.greasing.service_performed_by
        : "",
      next_greasing_start_date: "",
      next_greasing_end_date: "",
      next_greasing_performed: "GREASING",
      next_greasing_performed_by: "",
    });
  }

  saveGreasingModalDataBox() {
    this.loader = true;
    let body = {
      subsystem_id: this.meter_data.subsystem_id,
      start_date: this.gform.value.next_greasing_start_date,
      end_date: this.gform.value.next_greasing_end_date,
      user_id: this.meter_data.client_id,
      type: "g",
      service_performed: this.gform.value.next_greasing_performed,
      service_performed_by: this.gform.value.next_greasing_performed_by,
    };
    console.log(body);
    this.service
      .updateServiceRecordData(`${this.emeterData}/service-record`, body)
      // .updateServiceRecordData(
      //   `http://localhost:3105/emeter/service-record`,
      //   body
      // )
      .then((data: any) => {
        if (data.isSuccess) {
          this.saveGreasingModalData.emit();
        }
      })
      .catch(() => {})
      .finally(() => {
        this.loader = false;
      });
  }

  closeGreasingModalBox() {
    this.closeGreasingModal.emit(false);
  }
  setInitialServiceForm() {
    this.form.setValue({
      last_service_start_date: this.service_data.service.start_date
        ? this.service_data.service.start_date.split(" ")[0]
        : "",
      last_service_end_date: this.service_data.service.end_date
        ? this.service_data.service.end_date.split(" ")[0]
        : "",
      last_service_performed: this.service_data.service.service_performed
        ? this.service_data.service.service_performed
        : "",
      last_service_performed_by: this.service_data.service.service_performed_by
        ? this.service_data.service.service_performed_by
        : "",
      next_service_start_date: "",
      next_service_end_date: "",
      next_service_performed: "",
      next_service_performed_by: "",
    });
  }

  // saveOutForServiceModalBox() {
  //   this.loader = true;
  //   this.service
  //     .updateOFSData(
  //       `${this.emeterData}/out-of-service/${this.subsystem_id}?value=${
  //         this.toggleValue == true ? 1 : 0
  //       }`
  //     )
  //     .then((data: any) => {
  //       if (data.isSuccess) {
  //         this.saveOFSModalData.emit(this.toggleValue);
  //       }
  //     })
  //     .catch(() => {})
  //     .finally(() => {
  //       this.loader = false;
  //     });
  // }

  saveOFSToggle() {
    this.loader=true;
    let body = {
      value: this.toggleValue,
      subsystem_id: this.meter_data.subsystem_id,
      service_id: this.service_id,
      type: "s",
    };
    if (this.toggleValue != true) {
      this.service
        .updateOFSData(`${this.emeterData}/greasing-record`, body)
        .then((data: any) => {
          if (data.isSuccess) {
            this.saveOFSModalData.emit(!this.toggleValue);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loader = false;
        });
    } else {
      // we are inserting data
      let body = {
        subsystem_id: this.meter_data.subsystem_id,
        client_id: this.meter_data.client_id,
        start_date: new Date(),
        type: "s",
      };
      this.service
        .insertData(`${this.emeterData}/greasing-record`, body)
        .then((data: any) => {
          if (data.isSuccess) {
            this.saveOFSModalData.emit(!this.toggleValue);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loader=false;
        });
    }
  }

  closeOutForServiceModalBox() {
    this.closeOFSModal.emit({ changed: false });
  }

  getHTMLDateTimeMinFormat(date = new Date()) {
    const pad = (num) => num.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are 0-based
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());

    this.today = `${year}-${month}-${day}`;
  }

  // -------------------------------------- GREASING MODAL V2 --------------------------------
  saveGreasingModalDataBoxV2() {
    this.loader = true;
    this.service
      .insertData(`${this.emeterData}/greasing-record`, {
        subsystem_id: this.meter_data.subsystem_id,
        client_id: this.meter_data.client_id,
        start_date: this.gformV2.value.last_greasing,
        end_date: this.gformV2.value.suggested_greasing_date,
        total_hrs: this.gformV2.value.nxt_running_hrs,
        type: "g",
      })
      .then((res) => {
        // close the modal 
        this.closeGreasingModal.emit(true);
      })
      .catch(() => {})
      .finally(() => {
        this.loader = false;
      });
  }

  calculateNextSuggestedGreasinDate(data: any) {
    const hrs = data;
    let today = new Date(this.gformV2.value.last_greasing);
    today.setDate(today.getDate() + hrs / 24);
    console.log(today.toISOString().split("T")[0]);
    this.gformV2.patchValue({
      suggested_greasing_date: today.toISOString().split("T")[0],
    });
  }
}
